export const GET_STORE_CREDITS = "CREDIT_ENGINE/GET_STORE_CREDITS";
export const SAVE_STORE_CREDITS = "CREDIT_ENGINE/SAVE_STORE_CREDITS";
export const ADD_CREDITS = "CREDIT_ENGINE/ADD_CREDITS";
export const GET_CREDITS_TRANSACTIONS = "CREDIT_ENGINE/GET_CREDITS_TRANSACTIONS";
export const SAVE_CREDITS_TRANSACTIONS = "CREDIT_ENGINE/SAVE_CREDITS_TRANSACTIONS";
export const UPDATE_STORE_CREDITS = "CREDIT_ENGINE/UPDATE_STORE_CREDITS";
